// @ts-check
// Interruptor "Confirmar automaticamente quando a pessoa pedir para sair" de um número de WhatsApp em Configurações >
// Canais (spec/whatsapp.md 12.5 e 18.6; contrato 09 de campanhas de WhatsApp, seção 12): ligado por padrão; só quem tem
// a flag WORKSPACE muda. A resposta automática vai uma vez a cada 24 h por número que pediu para sair.
import { html } from 'htm/preact';
import { useState } from 'preact/hooks';
import { updateWhatsappChannelSettings } from '../../data/whatsapp-campaigns.js';
import { Toggle } from '../../ui/feedback.js';
import { showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { t } from '../../i18n/index.js';

/** @param {{ channelId: string, settings: Record<string, any>, isAdmin: boolean }} props */
export function OptOutConfirmationToggle({ channelId, settings, isAdmin }) {
  const [isEnabled, setIsEnabled] = useState(settings?.optOutConfirmation !== false);
  const [isSaving, setIsSaving] = useState(false);
  const change = async (/** @type {boolean} */ value) => {
    setIsSaving(true);
    try {
      const updated = await updateWhatsappChannelSettings(channelId, value);
      setIsEnabled(updated?.settings?.optOutConfirmation !== false);
      showSuccessSnackbar(t('settings.channels.whatsapp.optOutConfirmationSaved'));
    } catch (error) {
      showErrorSnackbar(error);
    } finally {
      setIsSaving(false);
    }
  };
  return html`<div class="wa-opt-out-toggle" data-testid="whatsapp-opt-out-confirmation">
    <${Toggle} value=${isEnabled} disabled=${!isAdmin || isSaving} ariaLabel=${t('settings.channels.whatsapp.optOutConfirmation')} onChange=${change} />
    <div>
      <p class="wa-opt-out-toggle-title">${t('settings.channels.whatsapp.optOutConfirmation')}</p>
      <p class="wa-limit-help">${t('settings.channels.whatsapp.optOutConfirmationHelp')}</p>
      ${!isAdmin ? html`<p class="wa-limit-help">${t('settings.channels.whatsapp.optOutConfirmationAdminOnly')}</p>` : null}
    </div>
  </div>`;
}
